import { useEffect, useState } from 'react'

const secondsLeft = (target: number | null): number =>
  target === null ? 0 : Math.max(0, Math.ceil((target - Date.now()) / 1000))

const useSecondsUntil = (value?: string | null, offsetSeconds = 0): number => {
  const parsed = value ? new Date(value).getTime() : NaN
  const target = Number.isNaN(parsed) ? null : parsed + offsetSeconds * 1000
  const [seconds, setSeconds] = useState(() => secondsLeft(target))

  useEffect(() => {
    setSeconds(secondsLeft(target))

    if (target === null) {
      return undefined
    }

    const timer = setInterval(() => setSeconds(secondsLeft(target)), 1000)

    return () => clearInterval(timer)
  }, [target])

  return seconds
}

export default useSecondsUntil
